export class DetalleMonitoreo {
    public tipoReporte: string;
    public nombre: string;
    public periodo: string;
    public fechaAutorizacion: string;
    public identificadorGrupo: string;
    public grupo: string;
    public tipoCliente: number;
    public tipoDecision: string;
    public estatusComite: string;
    public ratingClassCa: number;
    public ratingClassVigente: number;
    public montoLineaAutorizada: string;
    public montoCuentasPagar: string;
    public disponible: string;
    public capacidadDePago: string;
    public paymentBehaviourCa: number;
    public fechaProrroga: string;
    public paymentBehaviourVigente: number;
    public carteraVencida: string;
    public condicionesComite: string;
    public observaciones: string;
    public estatusLinea: string;
    public extraLinea: string;
    public asesorFlotillas: string;
    public analistaFinanciero: string;
    public customerCare: string;
    public tipoFlotilla: string;
    public sucursales: number;
    public marca: string;
    public autorizacionCa: string;
    public prorroga: string;
    public diasDeProrroga: number;
    public lineaBloqueadaPp: string;
    public deudaRefacciones: string;
    public deudaOtros: string;
    public disponibilidadOtros: string;
    public incrementoTemporal: string;
    public incrementoTemporalWorkingCapital: string;
    public lineasAutorizadas: string;
    public deuda: string;
    public disponibilidad: string;
    public garantiaTotal: string;
    public iniciales: number;
    public inicialesUsadas: number;
    public totalInventario: number;
    public totalInventarioUsadas: number;
    public nuevas330: number;
    public nuevas360: number;
    public interesesVencidos: string;
    public montoPrestamoReestructura: string;
    public cnd: string;
    public asesorFo: string;
    public analistaDeLineas: string;
    public montoTotal: string;
    public disponibilidadWorkingCapital: string;
    public saldoAuxiliares: string;
  
    constructor() {
      this.tipoReporte = '';
      this.nombre = '';
      this.periodo = '';
      this.fechaAutorizacion = '';
      this.identificadorGrupo = '';
      this.grupo = '';
      this.tipoCliente = 0;
      this.tipoDecision = '';
      this.estatusComite = '';
      this.ratingClassCa = 0;
      this.ratingClassVigente = 0;
      this.montoLineaAutorizada = '0';
      this.montoCuentasPagar = '0';
      this.disponible = '0';
      this.capacidadDePago = '0';
      this.paymentBehaviourCa = 0;
      this.fechaProrroga = '';
      this.paymentBehaviourVigente = 0;
      this.carteraVencida = '';
      this.condicionesComite = '';
      this.observaciones = '';
      this.estatusLinea = '';
      this.extraLinea = '';
      this.asesorFlotillas = '';
      this.analistaFinanciero = '';
      this.customerCare = '';
      this.tipoFlotilla = '';
      this.sucursales = 0;
      this.marca = '';
      this.autorizacionCa = '';
      this.prorroga = '';
      this.diasDeProrroga = 0;
      this.lineaBloqueadaPp = '';
      this.deudaRefacciones = '';
      this.deudaOtros = '';
      this.disponibilidadOtros = '';
      this.incrementoTemporal = '';
      this.lineasAutorizadas = '';
      this.deuda = '';
      this.disponibilidad = '';
      this.garantiaTotal = '';
      this.iniciales = 0;
      this.totalInventario = 0;
      this.nuevas330 = 0;
      this.nuevas360 = 0;
      this.interesesVencidos = '';
      this.montoPrestamoReestructura = '';
      this.cnd = '';
      this.asesorFo = '';
      this.analistaDeLineas = '';
      this.montoTotal = '';
      this.disponibilidadWorkingCapital = '';
      this.saldoAuxiliares = '';
    }
  }
  